import React, { useEffect, useState } from "react";

import { TextField } from "@mui/material";
import Slider from "@mui/material/Slider";
import { Col, Row } from "react-bootstrap";
import "../../Assets/Styles/pages/imageProperties.scss";

const SlidersRow = ({
  size,
  sizeScale,
  sizeChanged,
  rotation,
  rotate,
  opacity,
  changeOpacity,
  src,
  fileState,
  userSliceState,
}) => {
  const [sizeLocal, setSizeLocal] = useState(0);
  const [opacityLocal, setOpacityLocal] = useState(opacity);
  const [scalePercentage, setScalePercentage] = useState(0);
  var imageContainerSize = src.sizeOfContainer;
  var canvasContainerSize = userSliceState.canvasSize;

  useEffect(() => {
    let scalePercentage = scaleToPercentage(size);
    setScalePercentage(scalePercentage);
  }, [size, sizeScale, imageContainerSize]);

  const scaleToPercentage = (size) => {
    var referenceSize = Math.max(
      imageContainerSize * sizeScale,
      canvasContainerSize * 2
    );
    let scalePercentage = parseFloat(
      ((size * imageContainerSize) / referenceSize).toFixed(2)
    );

    // setScalePercentage(scalePercentage)
    if (scalePercentage > 1) return 1;
    else return scalePercentage;
  };

  const handleChangeSize = (percent, choice) => {
    let value = parseFloat(percent);
    var maxImageContainerSize = Math.max(
      imageContainerSize * sizeScale,
      canvasContainerSize * 2
    );
    var newContainerSize = (value / 100) * maxImageContainerSize;
    var sizeValue = newContainerSize / imageContainerSize;

    let scalePercentage = scaleToPercentage(sizeValue);

    if (!isNaN(value) && scalePercentage >= 0.01 && scalePercentage <= 1) {
      if (choice) {
        setScalePercentage(scalePercentage);
      } else {
        setScalePercentage(percent / 100);
      }

      setSizeLocal(0);
      sizeChanged(sizeValue, !choice);
    } else if (!isNaN(value) && scalePercentage > 1) {
      sizeChanged(size, choice);
    } else {
      setSizeLocal(scalePercentage);
    }
    // }
  };

  return (
    <Row className="borderbottom text_15 Aktiv my-3 py-1 mx-2 m-0">
      <Row className=" m-0 px-0 mb-2 ">
        <Col className="d-flex justify-content-between align-items-center m-0 p-0 mb-2">
          <p className="p-0 m-0 mt-1">Size</p>
          <TextField
            className="w_50px text-center mb-1"
            inputProps={{ textAlign: "center", type: "number", min: "1" }}
            value={
              sizeLocal
                ? sizeLocal
                : parseInt((scalePercentage * 100).toFixed(1))
            }
            onChange={(event) => handleChangeSize(event.target.value, 1)}
            variant="standard"
          />
        </Col>
        <Slider
          className="slider"
          size="small"
          value={scalePercentage}
          step={0.01}
          min={0.01}
          max={1}
          onChange={(e, value) => handleChangeSize(value * 100, 0)}
          onChangeCommitted={(e, value) => {
            handleChangeSize(value * 100, 1);
          }}
        />
      </Row>
      <Row className=" m-0 px-0 mb-2 ">
        <Col className="d-flex justify-content-between align-items-center m-0 p-0 mb-2">
          <p className="p-0 m-0 mt-1">Rotate</p>
          <TextField
            className="w_50px text-center mb-1"
            inputProps={{ textAlign: "center", type: "number" }}
            value={rotation}
            onChange={(event) => {
              if (parseInt(event.target.value) === 0 || !event.target.value) {
                rotate(0);
              } else if (parseInt(event.target.value)) {
                if (parseInt(event.target.value) > 360) {
                  rotate(360);
                } else if (parseInt(event.target.value) < -360) {
                  rotate(-360);
                } else {
                  rotate(parseInt(event.target.value));
                }
              }
            }}
            variant="standard"
          />
        </Col>
        <Slider
          size="small"
          value={rotation}
          min={-360}
          max={360}
          onChange={(e, value) => {
            rotate(value);
          }}
        />
      </Row>
      {!fileState.batchurls.length ? (
        <Row className=" m-0 mb-3 px-0 pb-1 ">
          <Col className="d-flex justify-content-between align-items-center m-0 p-0 mb-2">
            <p className="p-0 m-0 mt-1">Opacity</p>
            <TextField
              className="w_50px text-center  mb-1"
              inputProps={{
                textalign: "center",
                type: "number",
                min: "0.1",
                max: "1",
                step: "0.01",
              }}
              value={opacityLocal}
              // endAdornment={<InputAdornment position="end">kg</InputAdornment>}
              onChange={(event) => {
                if (
                  !isNaN(event.target.value) &&
                  event.target.value >= 0.05 &&
                  event.target.value
                ) {
                  if (event.target.value > 1) {
                    setOpacityLocal(1);
                    changeOpacity(1);
                  } else {
                    setOpacityLocal(event.target.value);
                    changeOpacity(parseFloat(event.target.value));
                  }
                } else {
                  setOpacityLocal(0);
                  changeOpacity(0);
                }
                // if (event.target.value !== NaN && event.target.value >= 0.5 && event.target.value)
                //   changeOpacity(event.target.value)
                // else
                //   changeOpacity(opacity)
              }}
              variant="standard"
            />
          </Col>
          <Slider
            size="small"
            value={opacity}
            step={0.01}
            min={0.05}
            max={1.0}
            onChange={(e, value) => {
              changeOpacity(value);
              setOpacityLocal(value);
            }}
          />
        </Row>
      ) : null}
    </Row>
  );
};

export default SlidersRow;
